export default __webpack_public_path__ + "8fcdb7d1e0a37aaa50835e1d8e8cdd0b.svg";